"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SlideDialog;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _SlideTitle = _interopRequireDefault(require("./SlideTitle"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    slideContainer: {
      flex: '1 1 auto',
      display: 'flex',
      position: 'relative',
      overflow: 'hidden',
      minHeight: 400,
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }
    },
    slide: {
      position: 'absolute',
      width: '100%',
      minWidth: '100%',
      height: '100%',
      transition: theme.transitions.create(['left', 'opacity'], {
        duration: theme.transitions.duration.complex
      }),
      display: 'flex',
      flexDirection: 'column'
    },
    leftSlide: {
      left: 0,
      opacity: 1
    },
    leftSlideHidden: {
      left: '-100%',
      opacity: 0
    },
    rightSlide: {
      left: 0,
      opacity: 1
    },
    rightSlideHidden: {
      left: '100%',
      opacity: 0
    }
  });
});

function SlideDialog(_ref) {
  var open = _ref.open,
      setDialogOpen = _ref.setDialogOpen,
      title = _ref.title,
      subtitle = _ref.subtitle,
      titleActions = _ref.titleActions,
      dialogProps = _ref.dialogProps,
      _ref$defaultSlideInde = _ref.defaultSlideIndex,
      defaultSlideIndex = _ref$defaultSlideInde === void 0 ? 0 : _ref$defaultSlideInde,
      children = _ref.children;
  var classes = useStyles();

  var onClose = function onClose() {
    return setDialogOpen(false);
  };

  var _useState = (0, _react.useState)(defaultSlideIndex),
      _useState2 = _slicedToArray(_useState, 2),
      currentSlideIndex = _useState2[0],
      setSlideIndex = _useState2[1];

  var displaySlide = function displaySlide() {
    var content = children(currentSlideIndex, setSlideIndex).map(function (slide, slideIndex) {
      var isLeft = slideIndex < currentSlideIndex;
      var showSlideClass = isLeft ? classes.leftSlide : classes.rightSlide;
      var hideSlideClass = isLeft ? classes.leftSlideHidden : classes.rightSlideHidden;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.slide, showSlideClass, _defineProperty({}, hideSlideClass, slideIndex !== currentSlideIndex)),
        key: slideIndex
      }, slide);
    });
    return content;
  };

  var TitleActionsElem = titleActions && titleActions(currentSlideIndex, setSlideIndex);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], _extends({
    open: open,
    onClose: onClose,
    fullWidth: true
  }, dialogProps), title && /*#__PURE__*/_react["default"].createElement(_SlideTitle["default"], {
    title: title,
    subtitle: subtitle,
    titleActions: TitleActionsElem
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.slideContainer
  }, displaySlide()));
}